<template lang="pug">
  .wrap
    JobAggregateSidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")
    .main
      .aggregation-jobs
        .aggregation-jobs-guideHead
          a.aggregation-jobs-guideHead-button(@click="openGuide" v-if="user.has_basic") 使い方
        h3(v-if="presentIndexData && index.aggType == 1") {{ aggTerm }}～の合計求人数
        h3(v-if="presentIndexData && index.aggType == 2") {{ aggTerm }}～の平均給与
        h3(v-if="presentIndexData && index.aggType == 3") {{ aggTerm }}～の平均出稿予算
        .search-results
          .no-data(v-if="emptyIndexData")
            | 集計対象のデータが確認できませんでした。条件を見直して再集計を行ってください。
        .search-results-table(v-if="presentIndexData")
          AggregateJobTable(
            :results="index.results"
            :aggType="index.aggType"
            :workPlaceFlg="index.workPlaceFlg"
            :verticalAxis="index.verticalAxis"
          )
        .search-results-chart(v-if="presentIndexData")
          AggregateJobChart(
            :aggData="index"
            :categories="this.categories"
            :series="this.series"
          )

    AggJobSearchConditionModal

    Footer
</template>

<script>
  import { mapState } from 'vuex'
  import { ErrorMessages, HumanErrorMessages } from '../../constants'
  import Footer from '../parts/Footer'
  import JobAggregateSidebar from '../parts/JobAggregateSidebar'
  import AggregateJobTable from '../parts/AggregateJobTable'
  import AggregateJobChart from '../parts/AggregateJobChart'
  import AggJobSearchConditionModal from '../parts/AggJobSearchConditionModal'

  export default {
    components: {
      JobAggregateSidebar,
      AggregateJobTable,
      AggregateJobChart,
      AggJobSearchConditionModal,
      Footer,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_AGGREGATE_JOB)
      }

      await store.dispatch('aggregateJob/fetchIndex', query)
    },
    data () {
      return {
        openSidebar: false,
        emptyIndexData: false,
        presentIndexData: false,
        categories: [],
        series: [],
      }
    },
    computed: {
      ...mapState({
        index: state => state.aggregateJob.index,
        user: state => state.user.detail,
      }),
      aggTerm () {
        return this.index.results[0].agg_result[0].month.replace('〜', '')
      },
    },
    methods: {
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      updateCurrentIndex () {
        const indexData = this.$store.state.aggregateJob.index

        if (indexData.results.length) {
          this.presentIndexData = true
          this.emptyIndexData = false
        } else {
          this.presentIndexData = false
          this.emptyIndexData = true
        }
      },
      updateChartData () {
        const indexData = this.$store.state.aggregateJob.index

        // 現在の平均チャート
        if (indexData.results.length) {
          // 横軸
          const month = []
          indexData.results[0].agg_result.forEach((agg) => {
            month.push(agg.month)
          })
          this.categories = month

          // 縦軸
          const seriesArray = []
          indexData.results.forEach((result) => {
            const seriesHash = {}
            const count = []

            // 求人数
            if (indexData.aggType === '1') {
              result.agg_result.forEach((agg) => {
                count.push(agg.job_count)
              })
            }

            // 給与
            if (indexData.aggType === '2') {
              result.agg_result.forEach((agg) => {
                if (agg.avg_salary_min === null) {
                  count.push(0)
                } else {
                  count.push(agg.avg_salary_min)
                }
              })
            }

            // 出稿予算
            if (indexData.aggType === '3') {
              result.agg_result.forEach((agg) => {
                if (agg.avg_article_plan === null) {
                  count.push(0)
                } else {
                  count.push(agg.avg_article_plan)
                }
              })
            }

            seriesHash.name = result.vertical_axis_name
            seriesHash.data = count
            seriesArray.push(seriesHash)
          })
          this.series = seriesArray
        }
      },
      openGuide () {
        window.open('/guide/market_analysis', '_blank', 'noreferrer')
      },
    },
    watch: {
      index () {
        this.updateCurrentIndex()
        this.updateChartData()
      },
    },
    created () {
      this.updateCurrentIndex()
      this.updateChartData()
    },
    mounted () {
      // 集計データ表示権限がない場合は求人検索に飛ばす
      if (!this.user.display_aggregations) {
        this.$store.dispatch('common/pushToastError', {
          error: new Error(HumanErrorMessages.FORBIDDEN),
        })
        this.$router.push({ name: 'SearchJob' })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/aggregate/AggregateJob.vue